<mat-card [padding]="8" class="fill" style="overflow: auto">
  <table
    mat-table
    #outerTable
    #outerSort="matSort"
    [dataSource]="dataSource"
    matSortActive="orderId"
    matSortDirection="asc"
    [multiTemplateDataRows]="true"
    class="mat-elevation-z8"
    matSort
  >
    <ng-container matColumnDef="lineDisplay">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <div>
          <mat-icon
            color="#505762"
            class="minimize"
            (click)="toggleRow(element)"
            *ngIf="expandedElement?.orderId === element.orderId"
            >arrow_downward</mat-icon
          >
          <mat-icon
            color="#505762"
            class="minimize"
            (click)="toggleRow(element)"
            *ngIf="expandedElement?.orderId !== element.orderId"
            >arrow_upward</mat-icon
          >
        </div>
      </td>
    </ng-container>
    <ng-container matColumnDef="orderNumber">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Order #</th>
      <td mat-cell *matCellDef="let element">{{ element.orderNumber }}</td>
    </ng-container>
    <ng-container matColumnDef="orderId">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Order Id</th>
      <td mat-cell *matCellDef="let element">{{ element.orderId }}</td>
    </ng-container>
    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
      <td mat-cell *matCellDef="let element">{{ element.status }}</td>
    </ng-container>
    <ng-container matColumnDef="createdOn">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Created On</th>
      <td mat-cell *matCellDef="let element">{{ element.createdOn | date : 'mediumDate' }}</td>
    </ng-container>
    <ng-container matColumnDef="userName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>User Name</th>
      <td mat-cell *matCellDef="let element">{{ element.userName }}</td>
    </ng-container>

    <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->

    <ng-container matColumnDef="expandedDetail">
      <td mat-cell class="greyBackground" *matCellDef="let element" [attr.colspan]="columnsToDisplay.length">
        <div class="example-element-detail" [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
          <div class="inner-table mat-elevation-z8">
            <!-- Line subline Header -->
            <table
              mat-table
              #sublineTables
              #innerSort="matSort"
              class="greyBackground"
              [dataSource]="sublineDataSource"
              matSortActive="lineNumber"
              matSortDirection="asc"
              matSort
            >
              <ng-container matColumnDef="customerAccountNumber">
                <th mat-header-cell *matHeaderCellDef [style.text-align]="center" [attr.colspan]="3">
                  Customer Account #: {{ element.customerAccountNumber }}
                </th>
              </ng-container>
              <ng-container matColumnDef="orderId">
                <th mat-header-cell *matHeaderCellDef [style.text-align]="center" [attr.colspan]="3">
                  order Id #: {{ element.orderId }}
                </th>
              </ng-container>
              <ng-container matColumnDef="oracleHeaderId">
                <th mat-header-cell *matHeaderCellDef [style.text-align]="center" [attr.colspan]="4">
                  Oracle Header Id: {{ element.oracleHeaderId }}
                </th>
              </ng-container>

              <!-- Line subline details -->

              <ng-container matColumnDef="lineNumber">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Line#</th>
                <td mat-cell *matCellDef="let element">{{ element.lineNumber }}</td>
              </ng-container>
              <ng-container matColumnDef="subLineNumber">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>subLine#</th>
                <td mat-cell *matCellDef="let element">{{ element.subLineNumber }}</td>
              </ng-container>
              <ng-container matColumnDef="groupName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>GroupName</th>
                <td mat-cell *matCellDef="let element">{{ element.groupName }}</td>
              </ng-container>
              <ng-container matColumnDef="prefix">
                <th mat-header-cell *matHeaderCellDef>Prefix</th>
                <td mat-cell *matCellDef="let element">{{ element.prefix }}</td>
              </ng-container>
              <ng-container matColumnDef="from">
                <th mat-header-cell *matHeaderCellDef>From</th>
                <td mat-cell *matCellDef="let element">{{ element.from }}</td>
              </ng-container>
              <ng-container matColumnDef="to">
                <th mat-header-cell *matHeaderCellDef>To</th>
                <td mat-cell *matCellDef="let element">{{ element.to }}</td>
              </ng-container>
              <ng-container matColumnDef="suffix">
                <th mat-header-cell *matHeaderCellDef>Suffix</th>
                <td mat-cell *matCellDef="let element">{{ element.suffix }}</td>
              </ng-container>
              <ng-container matColumnDef="setList">
                <th mat-header-cell *matHeaderCellDef>SetList</th>
                <td mat-cell *matCellDef="let element" [matTooltip]="element.setList" matTooltipPosition="right">
                  {{ element.setList }}
                </td>
              </ng-container>
              <ng-container matColumnDef="subLineQuantity">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>SubLineQuantity</th>
                <td mat-cell *matCellDef="let element">{{ element.subLineQuantity }}</td>
              </ng-container>
              <ng-container matColumnDef="keyCombination">
                <th mat-header-cell *matHeaderCellDef>KeyCombination</th>
                <td mat-cell *matCellDef="let element">{{ element.keyCombination }}</td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="sublineHeaderColumns"></tr>
              <tr mat-header-row *matHeaderRowDef="innerDisplayedColumns"></tr>

              <tr mat-row *matRowDef="let row; columns: innerDisplayedColumns"></tr>
            </table>
            <mat-divider></mat-divider>
            <mat-paginator
              class="inner-paginator-wrapper greyBackground"
              #sublinePagination
              [pageSize]="10"
              [pageSizeOptions]="[10, 20, 30, 40, 50]"
              showFirstLastButtons
            >
            </mat-paginator>
          </div>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></tr>
    <tr mat-row *matRowDef="let element; columns: columnsToDisplay"></tr>
    <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
  </table>
  <mat-divider></mat-divider>
  <mat-paginator
    class="paginator-wrapper"
    #orderPagination
    [pageSize]="10"
    (page)="pageEvents($event)"
    [pageSizeOptions]="[10, 20, 30, 40, 50]"
    showFirstLastButtons
  >
  </mat-paginator>
</mat-card>
